import Analysis from 'models/analysis';
import analysisApi from 'api/analysis';
import AnalysisTabs from 'components/analysisTabs';
import branchApi from 'api/branch';
import customerApi from 'api/customer';
import dealerApi from 'api/dealer';
import debounce from 'lodash/debounce';
import events from 'lib/events';
import getProductDict from 'page/customer/system/productDict';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import isEqualWith from 'lodash/isEqualWith';
import Loader from 'components/loader';
import LoadingButton from 'components/loadingBtn';
import moment from 'moment';
import path from 'path';
import poolApi from 'api/pool';
import Popup from 'components/layout/popup';
import productApi from 'api/product';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import throttle from 'lodash/throttle';
import ValidationGroup from 'helpers/validation';
import WaterAnalysis from './waterAnalysis';
import WaterProblems from './waterProblems';
import waterTesterApi from 'api/waterTester';
import partialDrains from './partialDrains';
import {setCookie, getCookie} from 'helpers/cookiesHelper';
import SpecialEvents from './specialEvents';
import { XFCAbout, XFCInventory } from 'lib/xfConnect';
import { getErrorCode, ScanningErrors } from 'services/errorCodes';
import ToolTip, {tooltipPositions} from '../../components/ToolTip.jsx';

import {
  chemicalBaseTypeNames,
  chemicalBaseTypes,
  productTypes,
  scanTypes,
  seasonTemperatureOverrides,
  seasonTypes,
  systemTypes,
  winterOxidizers,
  temperatureFormat,
  countries,
  xfName,
  manualScanner,
  LSKEY_SCANNER,
} from 'helpers/constants';
import {discTypes, discTypesCookiesKeys, preprocessData, scanDisabledFields} from 'helpers/scanHelpers';
import {FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape} from 'react-intl';
import TC from 'services/testConnect2p0';
import {getState} from 'services/testConnectState';
import {isProductTruBlue} from 'helpers/truBlue';
import SuggestedProductsSelection from './SuggestedProductsSelection';
import {fahrenheitToCelsius, celsiusToFahrenheit} from 'helpers/temperatureHelper';

// imports necessary to support socket scanning interface
import {old_render} from 'page/analysis/scanning.jsx';
import {UseHTTPScannerInterface} from 'lib/globals';

let old_or_new_render = (container, params) => {
  UseHTTPScannerInterface.then((val) => {
    if(val === true) {
      render(container, params);
    }else{
      old_render(container, params);
    }
  });
};

let render = (container, params) => {
  console.info('[UI.page.customer] rendering page');
  // Redirects route /analysis/report to /analysis
  if (params.analysisID && Number(params.analysisID).toString() !== params.analysisID) {
    window.location.hash = path.join(window.location.hash, '..');
  } else {
    events.publish('page-change', {page: 'customer'});

    var _id;
    var _contactid;

    if (params.id) {
      _id = parseInt(params.id.split('.')[0]);
      _contactid = parseInt(params.id.split('.').length > 1 ? params.id.split('.')[1] : null);
    }

    ReactDOM.render(
      <IntlWrapper>
        <WrapperScanning
          poolID={params.system}
          customerID={_id}
          contactId={_contactid}
          analysisID={params.analysisID}/>
      </IntlWrapper>,
      container
    );
  }
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'customer/:id/:system/analysis', handler: routeUtils.requireAuth(old_or_new_render)}]);
router.rr.add([{path: 'customer/:id/:system/analysis/:analysisID', handler: routeUtils.requireAuth(old_or_new_render)}]);

function unSub(x) {
  if (x && x.remove && typeof x.remove === 'function') {
    x.remove();
  }
}

// Page object
class Scanning extends React.Component {
  static displayName = 'Scanning';

  static propTypes = {
    customerID: PropTypes.number,
    poolID: PropTypes.string,
    analysisID: PropTypes.string,
    scanID: PropTypes.string,
    intl: intlShape.isRequired,
    contactId: PropTypes.any,
  };

  state = {
    analysis: new Analysis({}),
    analysisWorkingCopy: new Analysis({}),
    branch: {},
    customer: {
      customerContacts: [],
    },
    dealer: {},
    disabledFields: [],
    edit: true,
    historyId: null,
    isValidating: false,
    loaded: false,
    manualScan: true,
    xfScan: false,
    noScannersFound: false,
    partialDrainAnswered: false,
    partialDrainVisible: false,
    cleanAndDrainVisible: false,
    ncDrainEnabled: false,
    pool: {},
    products: [],
    sanitizerName: '',
    sanitizerType: 0,
    saving: false,
    scanners: ['Manual'],
    isScanning: false,
    scanResetDelay: 0,
    securityError: false,
    selectedScanner: null,
    selectedDisc: discTypes()[0],
    sourceWaterUpdate: false,
    sourceWaterTest: new Analysis({sourceWaterType: 'City'}),
    testers: [],
    warningFieldIds: {},
    SLSMustUpdate: false,
    SLSAvailableFirmware: '',
    Flex1: null,
    Flex2: null,
    Flex3: null,
    Flex4: null,
    cleanAndDrainResolvePromise: undefined
  };

  componentWillMount() {
    let {formatMessage} = this.props.intl;

    events.publish('scannerProgress.noClickable');

    this._save = throttle(this.saveAnalysis, 2000, {trailing: false});
    this.group = new ValidationGroup(this._save, this.toggleValidation);

    if (!session.getUser().privileges.canWaterTest) {
      events.publish('error.user', {message: formatMessage({id: 'scanning.error.not.authorized'})});
    }

    // Look for persisted state in session and restore if possible
    this.checkSessionData();

    this._firmwareUpdateDone = events.subscribe('firmware.updateDone', () => this.initializeScanner());
    this._scanStartSub = events.subscribe('scanner.start', () => this.setState({isScanning: true}));
    this._scanCancelSub = events.subscribe('scanner.cancel', () => {
      if (this.mounted) {
        this.setState({
          isScanning: false,
          isValidating: false,
          disabledFields: [],
        });
      }
    });
    this._scanCompleteSub = events.subscribe('scanner.complete', (data) => {
      this.parseScanResults(data);
    });
    this._analysisChangedSub = events.subscribe('testconnect.analysisChanged', () => {
      this.ignoreProps = true;
      this.checkSessionData();
    });
    this._scannerFieldWarning = events.subscribe('error.scannerFieldWarning', (warningFieldIds) => {
      this.setState({
        warningFieldIds: warningFieldIds,
      });
    });

    this.partialDrainCheck = debounce(analysis => this.setState(partialDrains({
      analysis,
      dealer: this.state.dealer || {},
      branch: this.state.branch || {},
      formatMessage: this.props.intl.formatMessage,
      sanitizerType: this.state.sanitizerType,
      pool: this.state.pool || {},
      products: this.state.products || [],
    })), 750);
  }

  componentDidMount() {
    this.mounted = true;
    events.publish('scanpage.displayModal', true);
    this.titrationTestingListener = events.subscribe('dealeruser.toggleTitrationTestingOnly', () => this.initializeScanner());
  }

  componentWillReceiveProps(props) {
    if (!this.ignoreProps) {
      this.props = props;
      // Look for persisted state in session and restore if possible
      let sessionData = session.getAnalysis(this.props.poolID);

      if (sessionData) {
        if (TC.results) {
          let analysisWorkingCopy = preprocessData(TC.results, sessionData.analysisWorkingCopy, this.state.selectedScanner, this.state.sanitizerType, this.state.selectedDisc);

          sessionData = Object.assign({}, sessionData, {analysisWorkingCopy});
        }
        this.setState(sessionData);
      } else {
        this.fetchData();
      }
    } else {
      this.ignoreProps = false;
    }
  }

  componentWillUnmount() {
    this.mounted = false;

    events.publish('scannerProgress.clickable');
    if (this.shouldPersist) {
      session.persistAnalysis(this.state);
    }

    unSub(this._firmwareUpdateDone);
    unSub(this.titrationTestingListener);
    unSub(this._analysisChangedSub);
    unSub(this._scanCancelSub);
    unSub(this._scanCompleteSub);
    unSub(this._scanStartSub);
    unSub(this._scannerFieldWarning);
  }

  checkSessionData = () => {
    let sessionData = session.getAnalysis(this.props.poolID);

    if (!sessionData) {
      this.initializeScanner();
      this.fetchData();
      return;
    }

    if (sessionData.fromHistory) {
      let analysisWorkingCopy = preprocessData(sessionData.initialAnalysis,
        new Analysis(sessionData.analysisWorkingCopy),
        sessionData.scanner || sessionData.selectedScanner,
        sessionData.sanitizerType,
        sessionData.diskType);

      sessionData = Object.assign({}, sessionData, {analysisWorkingCopy});
    } else if (TC.results) {
      let analysisWorkingCopy = preprocessData(TC.results,
        sessionData.analysisWorkingCopy,
        sessionData.scanner || sessionData.selectedScanner,
        sessionData.sanitizerType,
        sessionData.diskType);

      sessionData = Object.assign({}, sessionData, {analysisWorkingCopy});
    }
    //Reset partial drain
    sessionData.analysis.partialDrain = false;
    sessionData.analysisWorkingCopy.partialDrain = false;

     // Override selected scanner to be based on user's preferences (local storage)
     const userPreferenceScanner = localStorage.getItem(LSKEY_SCANNER);
    
     if (userPreferenceScanner && sessionData.scanners.includes(userPreferenceScanner)) {
       sessionData.selectedScanner = userPreferenceScanner;
     } else {
       localStorage.setItem(LSKEY_SCANNER, sessionData.selectedScanner);
     }
 
     // If soft swim sanitizer, select user preferred scanner (if not AccuFlex™) or manual scanner by default (AccuFlex™ to be greyed out)
     if (sessionData.selectedScanner === xfName &&
       [chemicalBaseTypes.softswimPool, chemicalBaseTypes.softSoakSpa].indexOf(sessionData.sanitizerType) !== -1) {
         sessionData.selectedScanner = userPreferenceScanner && userPreferenceScanner !== xfName ? userPreferenceScanner : manualScanner;
         localStorage.setItem(LSKEY_SCANNER, sessionData.selectedScanner);
     }
 
     sessionData.manualScan = sessionData.selectedScanner === 'Manual';
     sessionData.xfScan = sessionData.selectedScanner === xfName;

    this.setState(sessionData, () => {
      if (!this.state.isScanning || TC.isScanning) {
        return;
      }

      this.setState({isScanning: false, disabledFields: [], isValidating: false, saving: false});
    });
  };

  acceptPartialDrain = (useNCCYARemoverDrain = false) => {
    let {formatMessage} = this.props.intl;
    let analysis = this.state.analysisWorkingCopy;

    analysis.partialDrain = true;
    analysis.partialDrainCYARemover = useNCCYARemoverDrain;

    analysisApi.saveAnalysis(analysis)
      .then(a => {
        let pool = session.getPool(a.poolID);

        if (pool) {
          session.deletePool(pool);
        }

        session.forgetAnalysis(this.props.poolID);
        this.shouldPersist = false;

        TC.reset(!session.getUser().titrationTestingOnly);


        if (!this.props.analysisID) {
          events.publish('scanner.cancel');
          window.location.hash = path.join(window.location.hash, 'report', a.id.toString());
        } else {
          window.location.hash = path.join(window.location.hash, '..', 'report', a.id.toString());
        }
      })
      .catch(e => {
        console.error(e);
        this.setState({isValidating: false, saving: false});
        events.publish('error.user', {message: formatMessage({id: 'scanning.error.saving.analysis'})});
      });
  };

  acceptPartialDrainCYARemover = () => {
    this.acceptPartialDrain(true);
  }

  changeScanner = (data) => {
    this.state.analysisWorkingCopy.scanTypeID = scanTypes[data.target.value];
    if (data.target.value.indexOf('Smart') < 0) {
      delete this.state.analysisWorkingCopy.diskType;
    }else{
      this.state.analysisWorkingCopy.diskType = this.state.selectedDisc;
    }
    this.setState({
      analysisWorkingCopy: this.state.analysisWorkingCopy,
      selectedScanner: data.target.value,
      manualScan: data.target.value === 'Manual',
      xfScan: data.target.value === xfName,
    });

    localStorage.setItem(LSKEY_SCANNER, data.target.value);

  };

  checkPossibleCD = (am) => {
    if (!am.totalBromine && !am.freeChlorine) {
      return false;
    }

    let totalBromine = parseFloat(am.totalBromine);
    let freeChlorine = parseFloat(am.freeChlorine);
    let totalChlorine = parseFloat(am.totalChlorine);

    if (this.state.sanitizerType === chemicalBaseTypes.brominePool) {
      if (totalBromine < 0.5 && (am.season === 'springopening' || this.state.pool.prevPossibleCD)) {
        return true;
      }
    } else if ([chemicalBaseTypes.chlorinePool, chemicalBaseTypes.saltWaterPool].indexOf(this.state.sanitizerType) !== -1) {
      if (freeChlorine < 0.5 && (am.season === 'springopening' || this.state.pool.prevPossibleCD)) {
        return true;
      }
    } else if (this.state.sanitizerType === chemicalBaseTypes.mineralSpringsPool) {
      if (freeChlorine < 0.5 && (am.startup || this.state.pool.prevPossibleCD)) {
        return true;
      }
    }

    //ALEX-789
    //(Limited to the systems that can make a chlorine demand test)
    if ([chemicalBaseTypes.chlorinePool, chemicalBaseTypes.chlorineSpa,
      chemicalBaseTypes.mineralSpringsPool, chemicalBaseTypes.saltWaterPool].indexOf(this.state.sanitizerType) !== -1 &&
      totalChlorine === 0 && freeChlorine === 0) {
      return true;
    }

    return false;
  };

  collapseAnalysis = () => {
    this.setState({collapsedAnalysis: true, collapsedProblems: false});
    if (this.state.isScanning) {
      events.publish('ga.event', {category: 'User', action: 'scan-next-scanning'});
    } else {
      events.publish('ga.event', {category: 'User', action: 'scan-next-done-scanning'});
    }
  };

  collapseProblems = () => {
    this.setState({collapsedAnalysis: false, collapsedProblems: true});
  };

  dataChanged = (e) => {
    let {formatMessage} = this.props.intl;
    let analysis = this.state.analysisWorkingCopy.clone();
    let sourceWaterUpdate = this.state.sourceWaterUpdate;
    let dealer = this.state.dealer;

    analysis[e.key] = e.value;
    if (e.key === 'season') {
      analysis = this.validateSeasonTemperatureOverrides(analysis);

      if(analysis.season === seasonTypes.closing) {
        //Reset phosphate
        analysis.phosphate = null;
      }

      if(analysis.season === seasonTypes.closing || analysis.season === seasonTypes.outSeason) {
        //Reset Pollen and Special Events
        analysis.postPartyProduct = false;
        analysis.prePartyProduct = false;
        analysis.severeWeatherProduct = false;
        analysis.pollen = false;
        analysis.pollenProductID = dealer.country === countries.US ? 220 : 63;
      }
    }

    if(e.key === 'prePartyProduct' && !!e.value) {
      //Reset post party
      analysis.postPartyProduct = undefined;
    }

    if(e.key === 'postPartyProduct' && !!e.value) {
      //Reset pre party
      analysis.prePartyProduct = undefined;
    }

    if (e.key === 'pollen' && !!e.value) {
      // Default to Pool Complete 911 if dealer is from US, otherwise deafult to Pool Tonic
      analysis.pollenProductID = dealer.country === countries.US ? 223 : 63;
    }

    this.partialDrainCheck(analysis);

    analysis.possibleCD = this.checkPossibleCD(analysis);
    if (analysis.possibleCD) {
      events.publish('warn.user', {
        message: formatMessage({id: 'scanning.possible.chlorine.demand'}),
        key: 'possibleCD',
        customClass: 'chlorine-demand',
      });
    } else {
      events.publish('cancel.error', {key: 'possibleCD'});
    }

    if (e.key === 'ironStaining' || e.key === 'copperStaining') {
      events.publish('cancel.error', {key: 'winterMetalStaining'});
    }

    if (e.key === 'copper' && analysis.copperFromProduct && (!e.value || e.value <= 0 || e.value >= 1)) {
      analysis.copperFromProduct = false;
    }

    if(e.key === 'freshFill') {
      sourceWaterUpdate = !!e.value;
    }

    this.setState({analysisWorkingCopy: analysis, sourceWaterUpdate});
  };

  declinePartialDrain = () => {
    this.setState({partialDrainAnswered: true});
  };

  fetchData = () => {
    let {formatMessage} = this.props.intl;
    let apis = [
      customerApi.getCustomer(this.props.customerID),
      waterTesterApi.getWaterTesters(),
      poolApi.getPool(this.props.poolID, true),
      productApi.getProducts(),
      dealerApi.getDealer(session.getUser().dealerId),
      analysisApi.getLatest(this.props.poolID),
      analysisApi.getSourceWater(this.props.poolID),
    ];

    if (this.props.analysisID) {
      apis.push(analysisApi.getAnalysis(this.props.analysisID));
    }

    Promise.all(apis)
      .then(([customer, testers, pool, products, dealer, latestPoolAnalysis, sourceWaterTest, analysis]) => {
        let {productDict, pool: p} = getProductDict({pool: pool.clone(), products, dealer, formatMessage}); // Fixes pools with no products selected or deleted products selected

        // Replace api call with this since track the previous analysis date anyway
        let analysesThisYear = pool.prevAnalysisDate ? pool.prevAnalysisDate.year() === moment().year() : false;

        let season = seasonTypes.inSeason;

        if (p.typeID !== systemTypes.spa) {
          let now = moment();

          pool.seasonStart.year(now.year());
          pool.seasonEnd.year(now.year());

          if (!analysesThisYear &&
            now <= pool.seasonStart.add(dealer.seasonOpenMargin, 'weeks')) {
            season = seasonTypes.opening;
          } else if (now >= pool.seasonEnd.subtract(dealer.seasonEndMargin, 'weeks') &&
            now <= pool.seasonEnd.add(dealer.seasonEndMargin, 'weeks')) {
            season = seasonTypes.closing;
          } else if (analysesThisYear ||
            now >= pool.seasonStart.subtract(dealer.seasonOpenMargin, 'weeks') &&
            now <= pool.seasonEnd.subtract(dealer.seasonEndMargin, 'weeks')) {
            season = seasonTypes.inSeason;
          } else {
            // Bad side of in-season
            season = seasonTypes.closing;
          }

        }

        if (latestPoolAnalysis && latestPoolAnalysis.Season) {
          season = latestPoolAnalysis.Season; // Default to previous
          //Until the date falls into the Spring Opening date range per Season Usage date
          let now = moment();

          if (pool.seasonStart <= now && now <= pool.seasonStart.add(dealer.seasonOpenMargin, 'weeks')) {
            season = seasonTypes.opening;
          }
        }

        var winterizers = products.filter(p => p.productTypeID === productTypes.winterOxidizer);
        var hasDoNotCloseWinterizer = winterizers && winterizers
          .filter(w => w.code === winterOxidizers.doesNotClose && w.id === pool.winterOxidizer).length >= 1;
        // No winter closing for swim spas or  pool systems with 'Does not close' as winterizer

        if ((p.typeID === systemTypes.swimspa || hasDoNotCloseWinterizer) && season === seasonTypes.closing) {
          season = seasonTypes.inSeason;
        }

        // Reset season for pools that doesn't 'Does not close' as winterizer
        if (p.typeID === systemTypes.pool && !hasDoNotCloseWinterizer && season === seasonTypes.outSeason) {
          season = seasonTypes.opening;
        }

        let saveToState = poolToSave => {
          let filterCleanedDate = moment().subtract(43, 'days');
          let mSCellCleanedDate = moment().subtract(43, 'days');

          if (poolToSave.filterCleanedDate && poolToSave.filterCleanedDate.isValid()) {
            filterCleanedDate = poolToSave.filterCleanedDate;
          }
          if (poolToSave.mSCellCleanedDate && poolToSave.mSCellCleanedDate.isValid()) {
            mSCellCleanedDate = poolToSave.mSCellCleanedDate;
          }

          // Default Clarifier to Pool Complete 911 if Dealer country is US, otherwise default to Natural Clarifier
          const defaultClarifier = dealer.country === countries.US ? 223 : 60;

          // Default Swampy Product to Pool Complete 911 if Dealer country is US, otherwise default to Pool Tonic
          const defaultSwampyProduct = dealer.country === countries.US ? 223 : 63;

          // Default Cloudy Product to Pool Complete 911 if Dealer country is US, otherwise default to null (dropdown only for US)
          const defaultCloudyProduct = dealer.country === countries.US ? 223 : null;

          // Default Pollen Product to Pool Complete 911 if Dealer country is US, otherwise default to Pool Tonic
          const defaultPollenProduct = dealer.country === countries.US ? 223 : 63;

          let a = analysis && analysis.id ? analysis : new Analysis({
            testType: '2',
            filterCleanedDate: filterCleanedDate,
            mSCellCleanedDate: mSCellCleanedDate,
            lastCleanedDrained: poolToSave.lastCleanedDrained && poolToSave.lastCleanedDrained.isValid() ?
              poolToSave.lastCleanedDrained : moment().subtract(30, 'days'),
            poolID: this.props.poolID,
            season: season,
            algaeProduct: pool.typeID !== systemTypes.spa ? '28' : '40',
            clarifier: dealer.defaultProductHazyWater && dealer.defaultHazyProduct ? dealer.defaultHazyProduct : defaultClarifier,
            cDProduct: '17',
            scanTypeID: scanTypes.Manual,
            phosphate: null,
            displayInputTemperature: dealer.preferredTemperature,
            swampyProduct: dealer.defaultSwampyWater ? dealer.defaultSwampyWater : defaultSwampyProduct,
            pollen: false,
            pollenProductID: defaultPollenProduct,
            severeWeatherProduct: null,
            prePartyProduct: null,
            postPartyProduct: null,
            cloudy: false,
            cloudyProductID: defaultCloudyProduct,
          });

          //Clean old phosphateLevel
          a.phosphateLevel = null;

          //Reset partial drain
          a.partialDrain = false;
          a.partialDrainCYARemover = false;

          //Reset dd (demand drops)
          a.dd = null;

          //Cache pool chemical base type in the analysis
          a.chemicalBaseTypeID = poolToSave.chemicalBaseTypeID;

          //Reset winter closing analysis if winter closing season was pulled out
          if (a && a.id && (p.typeID === systemTypes.swimspa || hasDoNotCloseWinterizer) && a.season === seasonTypes.closing) {
            a.season = seasonTypes.inSeason;
            a.temperature = null;
          }

          //Reset winter closing analysis if winter closing season was pulled out
          if (a && a.id && (p.typeID === systemTypes.pool && !hasDoNotCloseWinterizer) && a.season === seasonTypes.outSeason) {
            a.season = seasonTypes.opening;
            a.temperature = null;
          }

          //Reset cd product for non proguard compatible sanitizer
          if(a && (a.cDProduct === '191' || a.cDProduct === 191) && !this.isType([1, 2])) {
            a.cDProduct = '17';
          }

          const currentMaintenanceClarifier = products.find(p => p && p.id === pool.maintClarifier);
          const prePartyKeys = [63, 205];

          if (!!currentMaintenanceClarifier && !!currentMaintenanceClarifier.wardenID && !prePartyKeys.includes(currentMaintenanceClarifier.wardenID)) {
            prePartyKeys.push(currentMaintenanceClarifier.wardenID);
          }

          //Reset prepartyProduct if it is not selected within the Pool Tonic, Pool First Aid or Maintenance Clarifier chosen
          if (!prePartyKeys.includes(a.prePartyProduct)) {
            a.prePartyProduct = null;
          }

          a = this.validateSeasonTemperatureOverrides(a);
          a = this.convertToFarenheitIFNeeded(a, dealer);

          //Reset season for spa to edit analysis for incoming changed winter pool
          a.season = p.typeID === systemTypes.spa ? seasonTypes.inSeason : a.season;

          testers = testers || [];

          // Add a blank water tester
          if (testers.length && testers[0].key !== -1) {
            testers = [{key: -1, name: formatMessage({id: 'scanning.select.tester'})}].concat(testers);
          }
          // Let the default water tester be blank
          if (!a.id) {
            a.waterTester = formatMessage({id: 'scanning.select.tester'});
          }
          let workingCopy = a.clone();

          if (TC.results) {
            workingCopy = preprocessData(TC.results, workingCopy, this.state.selectedScanner, this.state.sanitizerType, this.state.selectedDisc);
          }

          if (pool.winterMetalStaining) {
            events.publish('error.user', {
              message: formatMessage({id: 'scanning.last.offseason.winter'}),
              key: 'winterMetalStaining',
            });
          }

          if (!sourceWaterTest.sourceWaterType) {
            sourceWaterTest.sourceWaterType = 'City';
          }

          branchApi.getBranch(customer.branchID)
            .then(branch => {

              //Reset Hazy Product Clarifier if NC product and not NC is enabled for the store
              const naturalChemistyEnabled = !!branch && !!branch.naturalChemistry;

              if(a && a.clarifier === '205' && !naturalChemistyEnabled) {
                a.clarifier = '60';
              }

              if(workingCopy && workingCopy.clarifier === '205' && !naturalChemistyEnabled) {
                workingCopy.clarifier = '60';
              }

              //Reset Swampy Product if NC product and not NC is enabled for the store
              if(a && a.swampyProduct === 205 && !naturalChemistyEnabled) {
                a.swampyProduct = 63;
              }

              if(workingCopy && workingCopy.swampyProduct === 205 && !naturalChemistyEnabled) {
                workingCopy.swampyProduct = 63;
              }
              //Reset Swampy Product if Pool Tonic selected but Cannot vacuum to waste uncheck
              if (a && a.swampyProduct === 63 && !pool.cannotVacToWaste) {
                a.swampyProduct = 123;
              }

              if (workingCopy && workingCopy.swampyProduct === 63 && !pool.cannotVacToWaste) {
                workingCopy.swampyProduct = 123;
              }

               //Reset Swampy Product if Power Floc selected but Cannot vacuum to waste uncheck
              if (a && a.swampyProduct === 123 && (pool.cannotVacToWaste || dealer.country === countries.CA)) {
                a.swampyProduct = 63;
              }

              if (workingCopy && workingCopy.swampyProduct === 123 && (pool.cannotVacToWaste || dealer.country === countries.CA)) {
                workingCopy.swampyProduct = 63;
              }

              const newState = {
                analysis: a,
                analysisWorkingCopy: workingCopy,
                branch: branch,
                customer: customer,
                dealer: dealer,
                loaded: true,
                pool: poolToSave,
                products: products,
                selectedDisc: this.getDefaultDiscType(productDict.sanitizer.chemicalBaseType),
                sanitizerName: productDict.sanitizer.currentName,
                sanitizerType: productDict.sanitizer.chemicalBaseType,
                testers: testers,
                sourceWaterTest: sourceWaterTest,
              };

              const userPreferenceScanner = localStorage.getItem(LSKEY_SCANNER); // Check local storage scanner

              // Set pre-selected scanner from local storage
              if (userPreferenceScanner)  {
                newState.selectedScanner = userPreferenceScanner;
              } else {
                localStorage.setItem(LSKEY_SCANNER, this.state.selectedScanner);
              }

              // If soft swim sanitizer, select user preferred scanner (if not AccuFlex™) or manual scanner by default (AccuFlex™ to be greyed out)
              if (this.state.selectedScanner === xfName &&
                [chemicalBaseTypes.softswimPool, chemicalBaseTypes.softSoakSpa].indexOf(productDict.sanitizer.chemicalBaseType) !== -1) {
                newState.selectedScanner = userPreferenceScanner && userPreferenceScanner !== xfName ? userPreferenceScanner : manualScanner;
                localStorage.setItem(LSKEY_SCANNER, newState.selectedScanner);
              }

              newState.manualScan = newState.selectedScanner === 'Manual';
              newState.xfScan = newState.selectedScanner === xfName;

              this.setState(newState);
            });
        };

        if (!isEqualWith(pool, p, (a, b) => {
          if (moment.isMoment(a) && moment.isMoment(b)) {
            return !a.isValid() && !b.isValid() || a.diff(b) === 0;
          }
        })) {

          let isSanitizerTruBlue = isProductTruBlue(products, productTypes.sanitizer, dealer, p.chemicalBaseTypeID, p.sanitizer);
          let isMaintOxidizerTruBlue = isProductTruBlue(products, productTypes.maintOxidizer, dealer, p.chemicalBaseTypeID, p.maintOxidizer);
          let isPrevAlgicideTruBlue = isProductTruBlue(products, productTypes.prevAlgicide, dealer, p.chemicalBaseTypeID, p.prevAlgicide);
          let isMaintClarifierTruBlue = isProductTruBlue(products, productTypes.maintClarifier, dealer, p.chemicalBaseTypeID, p.maintClarifier);

          p.hasAllTruBlueProducts = isSanitizerTruBlue && isMaintOxidizerTruBlue && isPrevAlgicideTruBlue && isMaintClarifierTruBlue;

          poolApi.savePool(p).then(savedPool => {
            saveToState(savedPool);
          });
        }

        saveToState(p);
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: formatMessage({id: 'scanning.cannot.retrieve.data'})});
      });
  };

  getContactName = () => {
    let contact = null;
    let contactName = 'Customer';

    if (this.state.customer.customerContacts.length > 0) {
      contact = this.state.customer.customerContacts[0];

      for (let i = 0; i < this.state.customer.customerContacts.length; i++) {
        if (this.state.customer.customerContacts[i].id === this.props.contactId) {
          contact = this.state.customer.customerContacts[i];
        }
      }

      contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;
    }

    return contactName;
  };

  focusElement = '';

  handleSocketError = () => {
    // Set loading icon for 15 seconds to give accuscan time to reset
    let scanResetCountdown = setInterval(() => {
      let delay = this.state.scanResetDelay - 1;

      if (delay <= 0) {
        clearTimeout(scanResetCountdown);
      }
      this.setState({scanResetDelay: delay});
    }, 1000);

    this.setState({
      isScanning: false,
      isValidating: false,
      disabledFields: [],
      scanResetDelay: 30,
    });
  };

  initializeScanner = (preferManual = false) => {
    if (session.getUser().titrationTestingOnly) {
      this.setState({
        scannerInitialized: true,
        selectedScanner: 'Manual',
        noScannersFound: false,
      });
    } else {
      TC.getStatus(true)
        .then(status => {
          let disabledFields = [];
          let scanners = status.scanners;

          // Check if currently scanning on Smart Lab
          if (TC.isScanning && !TC.isXFCurrentScanner) {
            if (TC.isSmartLabCurrentScanner) {
              disabledFields = scanDisabledFields.SmartLab2p0[TC.currentDisk];
            }
          }

          // Check if currently scanning on AccuFlex™
          if (TC.isScanning && TC.isXFCurrentScanner) {
            disabledFields = scanDisabledFields.XpressFlex;
          }

          let selectedScanner = TC.currentScanner || scanners[0];

          const result = {
            disabledFields: disabledFields,
            manualScan: preferManual || selectedScanner === 'Manual',
            noScannersFound: scanners.length === 1, // 1 because 'Manual' is always an option,
            scannerInitialized: true,
            version: status.tc_version,
            scanners: scanners,
            isScanning: TC.isScanning,
            securityError: undefined,
            selectedScanner: preferManual ? 'Manual' : selectedScanner,
            SLSMustUpdate: status.sls_must_update,
            SLSAvailableFirmware: status.sls_available_firmware,
          };

          XFCAbout()
            .then((xfcStatus) => {
              if (xfcStatus.deviceConnected) {
                if (!result.scanners.includes(xfName)) result.scanners.push(xfName);
                result.selectedScanner = xfName;
                result.selectedDisc = null; //No disc required for XFC
                result.noScannersFound = false;
                result.manualScan = false;
                result.xfScan = true;
                
                // Grab AccuFlex™ Inventory information and update XF lot codes in beaker
                XFCInventory().then((results) => {
                  if (results.flexStrips && results.flexStrips.openBottleStripInventory) {
                    const newInventoryState = {};
                    const inventory = results.flexStrips.openBottleStripInventory;
                    for (const [stripName, stripInfo] of Object.entries(inventory)) {
                      if (stripInfo.code) {
                        newInventoryState[stripName] = stripInfo.code;
                      }
                    }
                    if (Object.keys(newInventoryState).length !== 0) {
                      this.setState(newInventoryState);
                    }
                  }
                }).catch((err) => console.error(err));
              }
            })
            .catch(err => {
              console.error(err);
            })
            .finally(() => this.setState(result));
        })
        .catch(err => {
          this.setState({scannerInitialized: true});
        });
    }
  };

  isType = (types) => {
    return types.indexOf(this.state.sanitizerType) !== -1;
  };

  parseScanResults = (data) => {
    if (data) {
      let preprocessedData = preprocessData(data, this.state.analysisWorkingCopy, this.state.selectedScanner, this.state.sanitizerType, this.state.selectedDisc, true);

      this.setState({
        disabledFields: [],
        isScanning: TC.isScanning,
        analysisWorkingCopy: preprocessedData,
      });

      TC.storeHistory({
        id: this.state.historyId,
        name: this.getContactName(),
        scanner: this.state.selectedScanner,
        time: new Date(),
        analysis: data,
        data: {
          saved: false,
          state: this.state,
        },
      });
    }
    this.partialDrainCheck(this.state.analysisWorkingCopy); // Check drains after scanner

    setTimeout(() => {
      events.publish('testconnect.historyChanged');
    }, 1000);
  };

  getSkipCleanAndDrain = async () => {
    const {typeID: poolTypeID} = this.state.pool;
    const {cleanAndDrain, lastCleanedDrained, freshFill} = this.state.analysisWorkingCopy;
    const {spaDrainFrequency} = this.state.dealer;

    if(!freshFill && !cleanAndDrain && poolTypeID === 2 ){
      const a = moment().diff(moment(lastCleanedDrained), 'months');
      if( moment().diff(moment(lastCleanedDrained), 'months') >= spaDrainFrequency){
        return await new Promise((resolve) =>  {      
          this.setState({cleanAndDrainVisible: true, cleanAndDrainResolvePromise: resolve});
        });
      }
    }

    return false;
  };

  acceptCleanAndDrain = () => {
    this.setState({cleanAndDrainVisible: false}, () => this.state.cleanAndDrainResolvePromise(false));
  }

  declineCleanAndDrain = () => {
    this.setState({cleanAndDrainVisible: false}, () => this.state.cleanAndDrainResolvePromise(true));
  }

  saveAnalysis = async (suggestedProducts = []) => {
    let {formatMessage} = this.props.intl;

    let analysis = this.state.analysisWorkingCopy;

    analysis.skipCleanAndDrain = await this.getSkipCleanAndDrain();

    analysis.suggestedProducts = suggestedProducts.map(x => x.product);

    analysis.contactId = this.props.contactId;
    //Always send Celsius for CA to the backend
    if(this.state.dealer.country === 'CA' && analysis.displayInputTemperature === temperatureFormat.FARENHEIT &&
      analysis.season !== seasonTypes.closing && analysis.season !== seasonTypes.outSeason) {
      analysis.temperature = fahrenheitToCelsius(analysis.temperature);
    }

    let apis = [
      analysisApi.saveAnalysis(analysis),
    ];

    if(!!this.state.sourceWaterUpdate) {
      let sourceWaterTestAnalysis = this.state.sourceWaterTest;

      sourceWaterTestAnalysis.tDS = analysis.tDS;
      sourceWaterTestAnalysis.pH = analysis.pH;
      sourceWaterTestAnalysis.copper = analysis.copper;
      sourceWaterTestAnalysis.totalChlorine = analysis.totalChlorine;
      sourceWaterTestAnalysis.alkalinity = analysis.alkalinity;
      sourceWaterTestAnalysis.iron = analysis.iron;
      sourceWaterTestAnalysis.freeChlorine = analysis.freeChlorine;
      sourceWaterTestAnalysis.hardness = analysis.hardness;
      sourceWaterTestAnalysis.manganese = analysis.manganese;
      sourceWaterTestAnalysis.waterTester = analysis.waterTester;

      apis.push(analysisApi.saveAnalysis(sourceWaterTestAnalysis, this.state.customer.id));
    }

    Promise.all(apis)
    .then(([a]) => {
      let pool = session.getPool(a.poolID);

      if (pool) {
        session.deletePool(pool);
      }

      session.forgetAnalysis(this.props.poolID);
      this.shouldPersist = false;

      TC.reset(!session.getUser().titrationTestingOnly);

      let locationHash;

      if (!this || !this.props || !this.props.analysisID) {
        locationHash = path.join(window.location.hash, 'report', a.id.toString());
      } else {
        locationHash = path.join(window.location.hash, '..', 'report', a.id.toString());
      }

      if (this.state.historyId) {
        TC.updateHistory({
          id: this.state.historyId,
          data: {
            saved: true,
            url: locationHash,
          },
        });

        setTimeout(() => {
          events.publish('testconnect.historyChanged');
        }, 1000);
      }

      window.location.hash = locationHash;
    })
      .catch(e => {
        console.error(e);
        this.setState({saving: false, isValidating: false});
        events.publish('error.user', {message: formatMessage({id: 'scanning.error.saving.analysis'})});
      });
    this.setState({saving: true});
  };

  getDefaultDiscType = (chemicalBaseType) => {
    if ([
      chemicalBaseTypes.chlorinePool,
      chemicalBaseTypes.mineralSpringsPool,
      chemicalBaseTypes.brominePool,
      chemicalBaseTypes.chlorinePool,
      chemicalBaseTypes.chlorineSpa,
      chemicalBaseTypes.bromineSpa,
      chemicalBaseTypes.mineralSpringsPool,
      chemicalBaseTypes.saltWaterPool,
      chemicalBaseTypes.saltWaterSpa,
      chemicalBaseTypes.synergyPool,
      chemicalBaseTypes.synergySpa,
    ].indexOf(chemicalBaseType) !== -1) {
      let cookieValue = getCookie(discTypesCookiesKeys.halogenDisk);

      if (!cookieValue || discTypes(chemicalBaseType).indexOf(cookieValue) < 0) {
        cookieValue = setCookie(discTypesCookiesKeys.halogenDisk, discTypes(chemicalBaseType)[0], 365); // Store for a year
      }

      return cookieValue;
    } else if ([chemicalBaseTypes.softswimPool, chemicalBaseTypes.softSoakSpa].indexOf(chemicalBaseType) !== -1) {
      let cookieValue = getCookie(discTypesCookiesKeys.biguanideDisk);

      if (!cookieValue || discTypes(chemicalBaseType).indexOf(cookieValue) < 0) {
        cookieValue = setCookie(discTypesCookiesKeys.biguanideDisk, discTypes(chemicalBaseType)[0], 365); // Store for a year
      }

      return cookieValue;
    }

    return discTypes(chemicalBaseType)[0];
  }

  setDefaultDiskType = (disk) => {
    const chemicalBaseType = this.state.sanitizerType;

    if ([
      chemicalBaseTypes.chlorinePool,
      chemicalBaseTypes.mineralSpringsPool,
      chemicalBaseTypes.brominePool,
      chemicalBaseTypes.chlorinePool,
      chemicalBaseTypes.chlorineSpa,
      chemicalBaseTypes.bromineSpa,
      chemicalBaseTypes.mineralSpringsPool,
      chemicalBaseTypes.saltWaterPool,
      chemicalBaseTypes.saltWaterSpa,
      chemicalBaseTypes.synergyPool,
      chemicalBaseTypes.synergySpa,
    ].indexOf(chemicalBaseType) !== -1) {
      setCookie(discTypesCookiesKeys.halogenDisk, disk, 365); // Store or renew for a year
    } else if ([chemicalBaseTypes.softswimPool, chemicalBaseTypes.softSoakSpa].indexOf(chemicalBaseType) !== -1) {
      setCookie(discTypesCookiesKeys.biguanideDisk, disk, 365); // Store or renew for a year
    }
  }

  setScannerDiskType = (event) => {
    this.setDefaultDiskType(event.target.value);
    this.state.analysisWorkingCopy.diskType = event.target.value;
    this.setState({
      analysisWorkingCopy: this.state.analysisWorkingCopy,
      selectedDisc: event.target.value}
    );
  }

  /**
   * Updates the AccuFlex™ inventory lot codes by sending a request to the XFC service
   *
   */
   updateXFCInventory = () => {
    XFCInventory([this.state.Flex1, this.state.Flex2, this.state.Flex3, this.state.Flex4])
      .then((results) => {
        // XFC returns errors through result codes
        if (results.systemErrorCode !== 0 || results.requestErrorCode !== 0) {
          console.error(results);
          let errorMessage = getErrorCode(ScanningErrors.XFC_INVENTORY_ERROR, xfName) || 'Unexpected Error for Inventory Update';

          // Show XFC system error message if exists
          if (results.systemErrorMsg && results.systemErrorCode) {
            const systemError = this.processXFCErrorMessage(results.systemErrorCode, results.systemErrorMsg);
            errorMessage = <React.Fragment>{errorMessage}{'\n'}{systemError}</React.Fragment>
          }

          // Show XFC request error message if exists
          if (results.requestErrorMsg && results.requestErrorCode) {
            const requestError = this.processXFCErrorMessage(results.requestErrorCode, results.requestErrorMsg, true);
            errorMessage = <React.Fragment>{errorMessage}{'\n'}{requestError}</React.Fragment>
          }

          events.publish('error.user',{
            message: errorMessage
          });

          return;
        }

        // Show success message upon inventory/lot code update
        events.publish('success.user',{
          message: <FormattedMessage id='general.xfc.invsuccess' />
        });
      })
      .catch((err) => {
        console.error(err);
        let errorMessage = getErrorCode(ScanningErrors.XFC_INVENTORY_ERROR, xfName) || 'Unexpected Error for Inventory Update';
        // No error code is thrown in the catch so just display the message if exists
        if (err.message) {
          const systemError = `System Error - "${err.message}"`;
          errorMessage = <React.Fragment>{errorMessage}{'\n'}{systemError}</React.Fragment>;
        }

        events.publish('error.user',{
          message: errorMessage
        });
      })
  };

  /**
   * Processes the XFC error results to set up an appropriate error message
   * with the error code and error message from copy
   * @param {Number} errorCode Error Code value from results
   * @param {string} [errorMessage='Unknown Error'] Error message
   * @param {boolean} [isRequestError=false] Checks if request error or not (i.e., system error)
   * @return {React.Fragment} Processed Error message
   */
   processXFCErrorMessage = (errorCode, errorMessage = 'Unknown Error', isRequestError = false) => {
    let processedErrorMsg = errorMessage;
    if (errorCode) {
      const errorID = `xfc.error.${errorCode}`;
      // Fallback to default error message
      const formattedMessage = <FormattedMessage id={errorID} defaultMessage={errorMessage} />

      let errorHeader;
      if (isRequestError) {
        errorHeader = `Request Error[${errorCode}]`;
        processedErrorMsg = <React.Fragment>{errorHeader}{' - '}{'"'}{formattedMessage}{'"'}</React.Fragment>
      }
      else {
        errorHeader = `System Error[${errorCode}]`;
        processedErrorMsg = <React.Fragment>{errorHeader}{' - '}{'"'}{formattedMessage}{'"'}</React.Fragment>;
      }
    }
    return processedErrorMsg;
  };

   /**
   * Renders the XFC Inventory selection for users to change XF strip lot codes
   *
   */
    renderXFCInventorySection = () => {
      return (
        <div>
          <div className='col-xs-2' style={{'marginTop': '8px', 'marginRight': '8px', 'width': '9%'}}>
            <div className='form-group'>
              <label><FormattedMessage id='general.xfc.flex1' /></label>
              <input type='text' className='form-control' onChange={e => this.setState({ Flex1: e.target.value })}
                defaultValue={this.state.Flex1} />
            </div>
          </div>
          <div className='col-xs-2' style={{'marginTop': '8px', 'marginRight': '8px', 'width': '9%'}}>
            <div className='form-group'>
              <label><FormattedMessage id='general.xfc.flex2' /></label>
              <input type='text' className='form-control' onChange={e => this.setState({ Flex2: e.target.value })}
                defaultValue={this.state.Flex2} />
            </div>
          </div>
          <div className='col-xs-2' style={{'marginTop': '8px', 'marginRight': '8px', 'width': '9%'}}>
            <div className='form-group'>
              <label><FormattedMessage id='general.xfc.flex3' /></label>
              <input type='text' className='form-control' onChange={e => this.setState({ Flex3: e.target.value })}
                defaultValue={this.state.Flex3} />
            </div>
          </div>
          <div className='col-xs-2' style={{'marginTop': '8px', 'marginRight': '8px', 'width': '9%'}}>
            <div className='form-group'>
              <label><FormattedMessage id='general.xfc.flex4' /></label>
              <input type='text' className='form-control' onChange={e => this.setState({ Flex4: e.target.value })}
                defaultValue={this.state.Flex4} />
            </div>
          </div>
          <div className='col-xs-7' style={{'marginTop': '26px'}}>
            <button className='btn btn-primary' style={{ 'marginLeft': '16px', 'marginRight': '4px', 'paddingLeft': '8px', 'paddingRight': '0'}}
                onClick={this.updateXFCInventory}><FormattedMessage id='general.xfc.lotcodes' /></button>
            <ToolTip style={{'marginTop': '4px'}} title={<FormattedMessage id='general.xfc.lot-tooltip' />}
            position={tooltipPositions.rightTop}
                iconOnly />
          </div>
        </div>
      );
    };  

  scannerSettings = () => {
    let {formatMessage} = this.props.intl;

    if (this.state.manualScan) {
      return <div/>;
    }

    let runScan = () => {
      this.startScan(
        this.state.pool.chemicalBaseTypeID,
        this.state.selectedDisc,
        this.state.xfScan,
      );
    };

    if (this.state.xfScan) {
      return (
        <React.Fragment>
        <div className='col-md-3' style={{ minHeight: '30px', marginTop: '18px' }}>
          <div className='form-group'>
            <LoadingButton
              className='btn btn-primary pull-right'
              onClick={runScan}
              loading={this.state.isScanning}
              disabled={this.state.isScanning}>
              {this.state.isScanning ? formatMessage({ id: 'general.scan.in.progress' }) : formatMessage({ id: 'general.start.scan' })}
            </LoadingButton>
          </div>
          </div>
          <div className='col-md-12' style={{ padding: '0px' }}>
            {this.renderXFCInventorySection()}
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className='col-md-3' style={{minHeight: '30px', marginTop: '18px'}}>
          <div className='form-group'>
            <LoadingButton
                className='btn btn-primary pull-right'
                onClick={runScan}
                loading={this.state.isScanning}
                disabled={this.state.isScanning}>
              {this.state.isScanning ? formatMessage({id: 'general.scan.in.progress'}) : formatMessage({id: 'general.start.scan'})}
            </LoadingButton>
          </div>
        </div>
        <div className='col-md-12' style={{padding: '0px'}}>
          <div className='col-md-5'>
            <div className='form-group'>
              <label><FormattedMessage id='scanning.select.test.disk'/></label>
              <select className='form-control'
                      value={this.state.selectedDisc}
                      onChange={this.setScannerDiskType}>
                {discTypes(this.state.sanitizerType).map(disc => <option key={disc} value={disc}>{disc}</option>)}
              </select>
            </div>
          </div>
          <div className='col-md-6' style={{minHeight: '30px', marginTop: '18px'}}>
            <FormattedMessage id='scanning.close.lid.before'/>
          </div>
        </div>
        <hr/>
      </React.Fragment>
    );
  };

  shouldPersist = true;

  startScan = (chemicalBaseTypeID, selectedDisc, isXFScan) => {
    // Update history id so if loads from an old scan first it resets
    let historyId = new Date().getTime().toString();

    this.setState({historyId}, () => {
      //Results are processed by the 'scanner.complete' event listener.
      if (isXFScan) {
        const isBromineScan = chemicalBaseTypeID === chemicalBaseTypes.brominePool || chemicalBaseTypeID === chemicalBaseTypes.bromineSpa;
        TC.startXFScan(isBromineScan);
        this.setState({isScanning: true, disabledFields: scanDisabledFields.XpressFlex});
        events.publish('ga.event', {category: 'Scan', action: 'XpressFlex'});
      } else {
        TC.startSmartLab(chemicalBaseTypeID, selectedDisc);
        this.setState({isScanning: true, disabledFields: scanDisabledFields.SmartLab2p0[selectedDisc]});
        events.publish('ga.event', {category: 'Scan', action: 'Spin'});
      }
      window.scrollTo(0, 0);
    });
  };

  toggleValidation = (newState = false) => {
    this.setState({isValidating: newState});
  };

  updateFocusElement = (el, precedence = true) => {
    if (precedence || !this.focusElement && el) {
      this.focusElement = el;
    }
  };

  validateAnalysis = (e, ...args) => {
    this.toggleValidation(true);
    this.group.validate(e, ...args);
  };

  validateSeasonTemperatureOverrides = (analysis) => {
    const {country} = this.state.dealer;
    const temperatureOverrides = seasonTemperatureOverrides(country);

    if (analysis.season === seasonTypes.closing || analysis.season === seasonTypes.outSeason) {
      analysis.temperature = temperatureOverrides[analysis.season];
    } else if (this.state.analysisWorkingCopy) {
      let prevAnalysisSeason = this.state.analysisWorkingCopy.season;

      if (prevAnalysisSeason === seasonTypes.outSeason || prevAnalysisSeason === seasonTypes.closing) {
        //Wipe previous temperature overrides
        analysis.temperature = undefined;
      }
    }
    return analysis;
  };

  convertToFarenheitIFNeeded = (analysis, dealer) => {
    const {country} = dealer;

    if(country === countries.CA && (!!analysis.temperature || analysis.temperature === 0) &&
      analysis.season !== seasonTypes.closing && analysis.season !== seasonTypes.outSeason &&
      analysis.displayInputTemperature !== temperatureFormat.CELSIUS) { //Always receive celsius from backend
      analysis.temperature = celsiusToFahrenheit(analysis.temperature);
    }
    return analysis;
  };

  render() {
    let {formatMessage} = this.props.intl;
    const {ncDrainEnabled} = this.state;

    if (this.state.securityError) {
      return (
        <div className='container'>
          <h3><FormattedMessage id='scanning.complete.water.test'/></h3>
          <br/>
          <p><a className='btn btn-default'
                href='#support/ie-security-error'><FormattedMessage
            id='general.click.troubleshoot'/></a></p>
        </div>
      );
    }

    let prevAlgicide = '';

    if (this.state.products.length > 0 && this.state.pool && this.state.pool.prevAlgicide) {
      let algicides = this.state.products.filter(x => x.id === this.state.pool.prevAlgicide);

      if (algicides.length > 0) {
        prevAlgicide = algicides[0].name;
      }
    }

    let pHBuffer = '';

    if (this.state.products.length > 0 && this.state.pool && this.state.pool.pHBuffer) {
      let buffers = this.state.products.filter(x => x.id === this.state.pool.pHBuffer);

      if (buffers.length > 0) {
        pHBuffer = buffers[0].name;
      }
    }

    let contactName = this.getContactName();

    //Generate customer id for url purpose
    let customerUrl = this.props.customerID.toString();

    if (!isNaN(this.props.contactId)) {
      customerUrl += '.' + this.props.contactId;
    }

    let subTitle = this.state.pool.softSoakTRIO ? 'Trio ' : '';

    subTitle += chemicalBaseTypeNames(this.state.pool.typeID, this.state.pool.chemicalBaseTypeID || 2, this.props.intl.formatMessage);
    let tagLine = this.state.pool.nickName ? this.state.pool.nickName : '';

    let alexProdID = this.state.customer && this.state.customer.accountNum ? <div className='heading-alexid'>
      <span className='heading-alexid-title'><FormattedMessage id='general.alexid'/>:</span> {this.state.customer.accountNum}
    </div> : null;

    return (
      <div className='container scanning-page'>
        <Loader loaded={this.state.loaded}>
          <Header mainTitle={contactName}
                  subTitle={subTitle}
                  mainTitleReturn={'customer/' + customerUrl}
                  tagLine={tagLine}>
            {alexProdID}
          </Header>
          <AnalysisTabs
            systemPath={this.props.analysisID ? path.join(location.hash, '..', '..') : path.join(location.hash, '..')}/>
          <Popup
            onAccept={debounce(this.acceptPartialDrain, 750)}
            onDecline={this.declinePartialDrain}
            title='Drain and Refill'
            message={this.state.partialDrainMessage}
            visible={this.state.partialDrainVisible && !this.state.partialDrainAnswered}
            customButtonText={ncDrainEnabled ? formatMessage({id: 'scanning.partial.drain.cya-remover'}) : null}
            customButtonAction={debounce(this.acceptPartialDrainCYARemover, 750)}/>
          <Popup
            onAccept={debounce(this.acceptCleanAndDrain, 750)}
            onDecline={this.declineCleanAndDrain}
            title={formatMessage({id: 'scanning.clean-and-drain.title'})}
            message={<FormattedHTMLMessage id={'scanning.clean-and-drain.message'}/>}
            visible={this.state.cleanAndDrainVisible}/>
          <WaterAnalysis
            analysis={this.state.analysisWorkingCopy}
            branch={this.state.branch}
            changeScanner={this.changeScanner}
            customer={this.state.customer}
            dataChanged={this.dataChanged}
            dealer={this.state.dealer}
            disabledFields={this.state.disabledFields}
            edit={this.state.edit}
            group={this.group}
            handshakeComplete={this.state.scannerInitialized}
            isType={this.isType}
            noScannersFound={this.state.noScannersFound}
            pHBuffer={pHBuffer}
            pool={this.state.pool}
            prevAlgicide={prevAlgicide}
            products={this.state.products}
            sanitizerName={this.state.sanitizerName}
            sanitizerType={this.state.sanitizerType || 0}
            isScanning={this.state.isScanning}
            scanners={this.state.scanners}
            version={this.state.version}
            scannerSettings={this.scannerSettings}
            selectedScanner={this.state.selectedScanner}
            testers={this.state.testers}
            updateFocusElement={this.updateFocusElement}
            useHTTPScannerInterface={true}
            warningFieldIds={this.state.warningFieldIds}
            SLSAvailableFirmware={this.state.SLSAvailableFirmware}
            SLSMustUpdate={this.state.SLSMustUpdate}/>
          {!this.state.SLSMustUpdate &&
            <SpecialEvents
              analysis={this.state.analysisWorkingCopy}
              dealer={this.state.dealer}
              branch={this.state.branch}
              dataChanged={this.dataChanged}
              edit={this.state.edit}
              group={this.group}
              isType={this.isType}
              pool={this.state.pool}
              products={this.state.products}/>
          }
          {!this.state.SLSMustUpdate &&
            <WaterProblems
              analysis={this.state.analysisWorkingCopy}
              dealer={this.state.dealer}
              branch={this.state.branch}
              dataChanged={this.dataChanged}
              edit={this.state.edit}
              group={this.group}
              isType={this.isType}
              pool={this.state.pool}
              updateFocusElement={this.updateFocusElement}/>
          }
          {!this.state.SLSMustUpdate &&
            <SuggestedProductsSelection branch={this.state.branch}
                                      chemicalBaseTypeID={this.state.sanitizerType}
                                      dealer={this.state.dealer}
                                      analysis={this.state.analysisWorkingCopy}
                                      saving={this.state.saving}
                                      saveAnalysis={this.validateAnalysis}
                                      isScanning={this.state.isScanning}
                                      isValidating={this.state.isValidating} />
          }
        </Loader>
      </div>
    );
  }
}

const WrapperScanning = injectIntl(Scanning);

export default Scanning;
